export const currentManagerSelector = state => state.general.currentManager;

export const currentManagerIdSelector = state =>
  state.general.currentManager.id;

export const currentManagerSkillGroupIdsSelector = state =>
  state.general.currentManager.skillGroupIds;

export const sessionIdSelector = state => state.general.sessionId;

export const serverTimeSelector = state => state.general.serverTime;
